import {createAction} from "@reduxjs/toolkit";

export const setArticleCategories = createAction('SET_ARTICLE_CATEGORIES');